import React, { useState } from 'react';
// HATA DÜZELTİLDİ: Derleme hatasına sebep olan NavDropdown ve Sidebar için Offcanvas buradaki listeye kalıcı olarak eklendi.
import { Badge, Navbar, Nav, Container, NavDropdown, Form, Button, InputGroup, Offcanvas } from 'react-bootstrap';
import { FaShoppingCart, FaUser, FaCogs, FaBolt, FaLink, FaChevronDown,FaTag,FaProjectDiagram,FaCode,FaGraduationCap } from 'react-icons/fa';
import { LinkContainer } from 'react-router-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import { clearCartItems } from '../slices/cartSlice';
import { resetDiscount } from '../slices/discountSlice';
import { useNavigate, useParams } from 'react-router-dom';

const InlineSearchBox = () => {
    const navigate = useNavigate();
    const { keyword: urlKeyword } = useParams();
    const [keyword, setKeyword] = useState(urlKeyword || '');

    const submitHandler = (e) => {
        e.preventDefault();
        if (keyword.trim()) {
            navigate(`/search/${keyword.trim()}`);
        } else {
            navigate('/');
        }
    };

    return (
        <Form onSubmit={submitHandler} className='d-flex w-100'>
            <InputGroup className="w-100">
                <Form.Control
                    type='text'
                    name='q'
                    onChange={(e) => setKeyword(e.target.value)}
                    value={keyword}
                    placeholder='Ürünleri arayın...'
                    style={{
                        borderColor: '#1a1a1a', 
                        borderWidth: '1.5px',
                        boxShadow: 'none',
                        fontSize: '0.88rem',
                        height: '46px',
                        borderTopLeftRadius: '4px',
                        borderBottomLeftRadius: '4px'
                    }}
                />
                <Button
                    type='submit'
                    className='px-4 border-0'
                    style={{
                        backgroundColor: '#2b2b2b', 
                        color: '#ffffff',
                        fontWeight: 'bold',
                        fontSize: '0.85rem',
                        height: '46px',
                        borderTopRightRadius: '4px',
                        borderBottomRightRadius: '4px',
                        transition: 'all 0.2s ease-in-out'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
                >
                    Ara
                </Button>
            </InputGroup>
        </Form>
    );
};
const Header = () => {
    const { cartItems } = useSelector((state) => state.cart);
    const { userInfo } = useSelector((state) => state.auth);
 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [logoutApiCall] = useLogoutMutation();
    const { keyword } = useParams();

    // HATA ÇÖZÜLDÜ: Tüm state'ler ve sidebar değişkenleri kurallara uygun şekilde buraya eklendi.
    const [isSaltHovered, setIsSaltHovered] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
      const [isProjeHovered, setIsProjeHovered] = useState(false);
      const [isYazilimHovered, setIsYazilimHovered] = useState(false);
      const [isEgitimHovered, setIsEgitimHovered] = useState(false);
    


    const logoutHandler = async () => {
        try {
            await logoutApiCall().unwrap();
            dispatch(logout());
            dispatch(clearCartItems());
            dispatch(resetDiscount());
            navigate('/login');
        } catch (err) {
            console.error(err);
        }
    };

    const handleCartClick = () => {
        navigate('/cart', {
            state: { post_id: keyword, post_id1: keyword }
        });
    };

    const handleCategoryClick = (categoryName) => {
        navigate(`/search/${encodeURIComponent(categoryName)}`);
        setIsSaltHovered(false); 
        setShowSidebar(false); // Sidebar veya menü üzerinden seçilince kapatır
         setIsProjeHovered(false);
         setIsYazilimHovered(false);
         setIsEgitimHovered(false);
    };
    return (
        <header className="adp-header border-bottom bg-white shadow-sm" style={{ display: 'block', width: '100%', position: 'relative', overflow: 'visible'  }}>
            {/* LOGO VE ARAMA ALANI (ÜST KATMAN) */}
            <Navbar bg="white" variant="light" expand="lg" collapseOnSelect className="py-0 border-bottom" style={{ overflow: 'visible' }}>
                <Container>
                    <LinkContainer to="/">
                        <Navbar.Brand className="p-0 m-0 d-flex align-items-center">
                            <img 
                                src='/images/Un2.jpg' 
                                width={225} 
                                height={126} 
                                alt="Logo" 
                                style={{ display: 'block', marginBottom: '0px' }}
                            />
                        </Navbar.Brand>
                    </LinkContainer>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" style={{ overflow: 'visible' }}>
                        <Nav className='align-items-center w-100' style={{ display: 'flex', flexDirection: 'row', overflow: 'visible' }}>
                            
                            <div className="my-2 my-lg-0 flex-grow-1" style={{ maxWidth: '550px', marginLeft: '25px', marginRight: '20px' }}>
                                <InlineSearchBox />
                            </div>

                            <div className="d-flex align-items-center ms-lg-3 gap-3">
                                <Nav.Link onClick={handleCartClick} className="fw-bold px-2 text-dark d-flex align-items-center">                
                                    <FaShoppingCart className="me-1" style={{ color: '#2b2b2b' }} /> Sepet                
                                    {cartItems.length > 0 && (
                                        <Badge pill bg='success' style={{ marginLeft: '5px' }}>
                                            {cartItems.reduce((a, c) => a + c.qty, 0)}
                                        </Badge>
                                    )}
                                </Nav.Link>

                                {userInfo ? (
                                    <NavDropdown title={userInfo.name} id='username' menuVariant="light" className="fw-bold px-2 text-dark">
                                        <LinkContainer to='/profile'>
                                            <NavDropdown.Item>Profilim</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to='/myorderlist'>
                                            <NavDropdown.Item>Siparişlerim</NavDropdown.Item>
                                        </LinkContainer>    
                                        <NavDropdown.Item onClick={logoutHandler}>
                                            Çıkış
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                ) : (
                                    <LinkContainer to="/login">
                                        <Nav.Link className="fw-bold px-2 text-dark d-flex align-items-center">
                                            <FaUser className="me-1" style={{ color: '#2b2b2b' }} /> Giriş Yap    
                                        </Nav.Link> 
                                    </LinkContainer>
                                )} 

                                {userInfo && userInfo.isAdmin && (
                                    <NavDropdown title='Admin' id='adminmenu' menuVariant="light" className="fw-bold px-2 text-dark" style={{ zIndex: 10010 }} >
                                        <LinkContainer to='/admin/productlist'>
                                            <NavDropdown.Item>Products</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to='/admin/userlist'>
                                            <NavDropdown.Item>Users</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to='/admin/orderlist'>
                                            <NavDropdown.Item>Orders</NavDropdown.Item>
                                        </LinkContainer>
                                    </NavDropdown>
                                )}
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* SİYAH BAR VE HOVER KONTROLLÜ GENİŞ GÖRSEL MEGA MENÜ PANELI */}
            <div className="d-none d-lg-block" style={{
                backgroundColor: '#000000', padding: '12px 0', width: '100%',
                position: 'relative', top: '126px', left: 0, zIndex: 1
            }}>
                <Container style={{ position: 'relative' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '40px', alignItems: 'center' }}>
                        
                        {/* HITBOX İYİLEŞTİRMESİ: Mouse'un başlık ile panel arasında kalırken menünün kapanmaması için kapsayıcı div kullanıldı */}
                        <div 
                            onMouseEnter={() => setIsSaltHovered(true)}
                            onMouseLeave={() => setIsSaltHovered(false)}
                            style={{ position: 'relative', display: 'inline-block', paddingBottom: '15px', marginBottom: '-15px' }}
                        >
                            {/* ŞALT MALZEMELERİ ANA BAŞLIĞI */}
                            <div
                                onClick={() => handleCategoryClick("Şalt Malzemeleri")} // Tıklanınca /search'e gider, HomeScreen sol sidebar'da Şalt Malzemeleri alt kategorilerini gösterir
                                style={{ 
                                    cursor: 'pointer', fontSize: '0.95rem', fontWeight: '900', 
                                    color: isSaltHovered ? '#66CCFF' : '#ffffff', 
                                    display: 'flex', alignItems: 'center', transition: 'color 0.2s ease-in-out',
                                    textTransform: 'uppercase', letterSpacing: '0.5px'
                                }}
                            >
                                <FaBolt style={{ marginRight: '6px', color: '#66CCFF' }} /> Şalt Malzemeleri <FaChevronDown style={{ fontSize: '0.7rem', marginLeft: '1px' }} />
                            </div>
                            
                            {/* 5 Sütunlu Izgara (Grid) Mega Panel Yapısı */}
                            {isSaltHovered && (
                                <div style={{
                                    position: 'absolute', top: '35px', left: '0px', width: '650px', 
                                    backgroundColor: '#ffffff', borderRadius: '6px', boxShadow: '0px 12px 32px rgba(0,0,0,0.18)',
                                    padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '15px', 
                                    zIndex: 100000, border: '1px solid #dcdcdc'
                                }}>
                                    {/* 1. ALT KATEGORİ: SİGORTA */}
                                    <div onClick={() => handleCategoryClick("Sigorta")} className="text-center" style={{ cursor: 'pointer', position: 'relative', zIndex: 100001 }}>
                                        <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                            <img src="/uploads/sigorta.jpg" alt="Sigorta" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/sigorta.jpg" }} />
                                        </div>
                                        <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444', textTransform: 'none' }}>Sigorta</span>
                                    </div>

                                    {/* 2. ALT KATEGORİ: MOTOR KORUMA ŞALTERİ */}
                                    <div onClick={() => handleCategoryClick("Motor Koruma Şalteri")} className="text-center" style={{ cursor: 'pointer', position: 'relative', zIndex: 100001 }}>
                                        <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                            <img src="/uploads/motorkoruma.jpg" alt="Motor Koruma Şalteri" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/mks.jpg" }} />
                                        </div>
                                        <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444', textTransform: 'none' }}>Motor Koruma Şalteri</span>
                                    </div>

                                    {/* 3. ALT KATEGORİ: KONTAKTÖR */}
                                    <div onClick={() => handleCategoryClick("Kontaktör")} className="text-center" style={{ cursor: 'pointer', position: 'relative', zIndex: 100001 }}>
                                        <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                            <img src="/uploads/kontaktor.jpg" alt="Kontaktör" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/kontaktor.jpg" }} />
                                        </div>
                                        <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444', textTransform: 'none' }}>Kontaktör</span>
                                    </div>

                                    {/* 4. ALT KATEGORİ: ŞALTER */}
                                    <div onClick={() => handleCategoryClick("Şalter")} className="text-center" style={{ cursor: 'pointer', position: 'relative', zIndex: 100001 }}>
                                        <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                            <img src="/uploads/salter.jpg" alt="Şalter" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/salter.jpg" }} />
                                        </div>
                                        <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444', textTransform: 'none' }}>Şalter</span>
                                    </div>

                                    {/* 5. ALT KATEGORİ: Kaçak Akım Rölesi */}
                                    <div onClick={() => handleCategoryClick("Röle")} className="text-center" style={{ cursor: 'pointer', position: 'relative', zIndex: 100001 }}>
                                        <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                                            <img src="/uploads/role.jpg" alt="Röle" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/kar.jpg" }} />
                                        </div>
                                        <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444', textTransform: 'none' }}>Kaçak Akım Rölesi</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* OTOMASYON BAŞLIĞI */}
                        <div 
                            onClick={() => handleCategoryClick("Otomasyon")}
                            style={{ 
                                cursor: 'pointer', fontSize: '0.95rem', fontWeight: '900', color: '#ffffff', 
                                display: 'flex', alignItems: 'center', transition: 'color 0.2s ease-in-out',
                                textTransform: 'uppercase', letterSpacing: '0.5px'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#66CCFF'} 
                            onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
                        >
                            <FaCogs style={{ marginRight: '6px', color: '#66CCFF' }} /> Otomasyon
                        </div>

                        {/* KABLO BAŞLIĞI */}
                        <div 
                            onClick={() => handleCategoryClick("Kablo")}
                            style={{ 
                                cursor: 'pointer', fontSize: '0.95rem', fontWeight: '900', color: '#ffffff',
                                display: 'flex', alignItems: 'center', transition: 'color 0.2s ease-in-out',
                                textTransform: 'uppercase', letterSpacing: '0.5px'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#66CCFF'} 
                            onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
                        >
                            <FaLink style={{ marginRight: '6px', color: '#66CCFF' }} /> Kablo
                        </div>
                         {/* FIRSAT ÜRÜNLER */}
                       <div 
                        onClick={() => handleCategoryClick("Fırsat Ürünler")}
                        style={{ 
                            cursor: 'pointer', fontSize: '0.95rem', fontWeight: '900', color: '#ffffff',
                            display: 'flex', alignItems: 'center', transition: 'color 0.2s ease-in-out',
                             textTransform: 'uppercase', letterSpacing: '0.5px'
                             }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#66CCFF'} 
                             onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
                            >
                            <FaTag style={{ marginRight: '6px', color: '#66CCFF' }} /> Fırsat Ürünler
                        </div>
 {/* PROJE UYGULAMALARI ANA BAŞLIĞI */}
<div 
    onMouseEnter={() => setIsProjeHovered(true)} 
    onMouseLeave={() => setIsProjeHovered(false)} 
    style={{ position: 'relative', display: 'inline-block', paddingBottom: '15px', marginBottom: '-15px' }}
>
    <div 
        onClick={() => navigate('/contactus',{ state: { selectedService: "Proje Uygulamaları" } })} // Ana başlığa tıklanınca da İletişim'e gider
        style={{ 
            cursor: 'pointer', fontSize: '0.95rem', fontWeight: '900', 
            color: isProjeHovered ? '#66CCFF' : '#ffffff', 
            display: 'flex', alignItems: 'center', transition: 'color 0.2s ease-in-out', 
            textTransform: 'uppercase', letterSpacing: '0.5px' 
        }}
    >
        <FaProjectDiagram style={{ marginRight: '6px', color: '#66CCFF' }} /> Proje Uygulamaları <FaChevronDown style={{ fontSize: '0.7rem', marginLeft: '1px' }} />
    </div>

    {/* 3 Sütunlu Izgara (Grid) Mega Panel Yapısı */}
    {isProjeHovered && (
        <div style={{
            position: 'absolute', top: '35px', left: '0px', width: '400px', 
            backgroundColor: '#ffffff', borderRadius: '6px', boxShadow: '0px 12px 32px rgba(0,0,0,0.18)',
            padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px', 
            zIndex: 100000, border: '1px solid #dcdcdc'
        }}>
            {/* 1. MAKİNE OTOMASYONU - ContactUs'a yönlendirir */}
            <div onClick={() => navigate('/contactus',{ state: { selectedService: "Makine Otomasyonu" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/makine-otomasyon.jpg" alt="Makine Otomasyonu" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/makinaOt.jpg" }} />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444' }}>Makine Otomasyonu</span>
            </div>

            {/* 2. FABRİKA PROSES OTOMASYONU - ContactUs'a yönlendirir */}
            <div onClick={() => navigate('/contactus',{ state: { selectedService: "Proses Fabrika Otomasyonu" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/proses-otomasyon.jpg" alt="Fabrika Proses Otomasyonu" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/prosesOt.jpg" }} />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444' }}>Fabrika Proses Otomasyonu</span>
            </div>

            {/* 3. HAREKET KONTROL & SERVO SİSTEMLER - ContactUs'a yönlendirir */}
            <div onClick={() => navigate('/contactus',{ state: { selectedService: "Hareket Kontrol & Servo Sistemler" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/servo-sistem.jpg" alt="Hareket Kontrol & Servo Sistemler" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/servoCon.jpg" }} />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444' }}>Hareket Kontrol & Servo Sistemler</span>
            </div>
        </div>
    )}
</div>



             
                            {/* YAZILIM */}
   {/* YAZILIM ANA BAŞLIĞI */}
<div 
    onMouseEnter={() => setIsYazilimHovered(true)} 
    onMouseLeave={() => setIsYazilimHovered(false)} 
    style={{ position: 'relative', display: 'inline-block', paddingBottom: '15px', marginBottom: '-15px' }}
>
    <div 
       onClick={() => navigate('/contactus',{ state: { selectedService: "Yazılım" } })} // Ana başlığa tıklanınca da İletişim'e gider
        style={{ 
            cursor: 'pointer', fontSize: '0.95rem', fontWeight: '900', 
            color: isYazilimHovered ? '#66CCFF' : '#ffffff', 
            display: 'flex', alignItems: 'center', transition: 'color 0.2s ease-in-out', 
            textTransform: 'uppercase', letterSpacing: '0.5px' 
        }}
    >
        <FaCode style={{ marginRight: '6px', color: '#66CCFF' }} /> Yazılım <FaChevronDown style={{ fontSize: '0.7rem', marginLeft: '1px' }} />
    </div>

    {/* 3 Sütunlu Yazılım Mega Panel Yapısı */}
    {isYazilimHovered && (
        <div style={{ 
            position: 'absolute', top: '35px', left: '0px', width: '400px', 
            backgroundColor: '#ffffff', borderRadius: '6px', boxShadow: '0px 12px 32px rgba(0,0,0,0.18)', 
            padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px', 
            zIndex: 100000, border: '1px solid #dcdcdc' 
        }}>
            {/* 1. ALT KATEGORİ: SCADA, HMI */}
             <div onClick={() => navigate('/contactus',{ state: { selectedService: "SCADA, HMI ve Panel Yazılımları" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/scada.jpg" alt="SCADA HMI" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/scada.jpg" }} />
                </div>
                <span style={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#444', display: 'block', lineHeight: '1.2' }}>SCADA, HMI ve Panel Yazılımları</span>
            </div>

            {/* 2. ALT KATEGORİ: VERİ DEPOLAMA (MES) */}
            <div onClick={() => navigate('/contactus',{ state: { selectedService: "Veri Depolama, İşleme ve Raporlama" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/mes.jpg" alt="Veri Depolama" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/mes.jpg" }} />
                </div>
                <span style={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#444', display: 'block', lineHeight: '1.2' }}>Veri Depolama, İşleme ve Raporlama</span>
            </div>

            {/* 3. ALT KATEGORİ: IoT & MOBİL */}
           <div onClick={() => navigate('/contactus',{ state: { selectedService: "IoT, Bilgisayar ve Mobil Uygulamalar" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/iot.jpg" alt="IoT Mobil" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/iot.jpg" }} />
                </div>
                <span style={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#444', display: 'block', lineHeight: '1.2' }}>IoT, Bilgisayar ve Mobil Uygulamalar</span>
            </div>
        </div>
    )}
</div>


                        {/* EĞİTİM BAŞLIĞI */}
{/* EĞİTİM ANA BAŞLIĞI */}
<div 
    onMouseEnter={() => setIsEgitimHovered(true)} 
    onMouseLeave={() => setIsEgitimHovered(false)} 
    style={{ position: 'relative', display: 'inline-block', paddingBottom: '15px', marginBottom: '-15px' }}
>
    <div 
        onClick={() => navigate('/contactus',{ state: { selectedService: "Eğitim" } })} // Ana başlığa tıklanınca da İletişim'e gider
        style={{ 
            cursor: 'pointer', fontSize: '0.95rem', fontWeight: '900', 
            color: isEgitimHovered ? '#66CCFF' : '#ffffff', 
            display: 'flex', alignItems: 'center', transition: 'color 0.2s ease-in-out', 
            textTransform: 'uppercase', letterSpacing: '0.5px' 
        }}
    >
        <FaGraduationCap style={{ marginRight: '6px', color: '#66CCFF' }} /> Eğitim <FaChevronDown style={{ fontSize: '0.7rem', marginLeft: '1px' }} />
    </div>

    {/* 3 Sütunlu Eğitim Mega Panel Yapısı */}
    {isEgitimHovered && (
        <div style={{ 
            position: 'absolute', top: '35px', left: '0px', width: '400px', 
            backgroundColor: '#ffffff', borderRadius: '6px', boxShadow: '0px 12px 32px rgba(0,0,0,0.18)', 
            padding: '20px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px', 
            zIndex: 100000, border: '1px solid #dcdcdc' 
        }}>
            {/* 1. ALT KATEGORİ: PLC */}
             <div onClick={() => navigate('/contactus',{ state: { selectedService: "PLC Eğitimi" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/plc.jpg" alt="PLC Eğitimi" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/plc.jpg" }} />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444' }}>PLC</span>
            </div>

            {/* 2. ALT KATEGORİ: HMI */}
             <div onClick={() => navigate('/contactus',{ state: { selectedService: "HMI Eğitimi" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/hmi.jpg" alt="HMI Eğitimi" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/hmi.jpg" }} />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444' }}>HMI</span>
            </div>

            {/* 3. ALT KATEGORİ: MOTION CONTROL */}
             <div onClick={() => navigate('/contactus',{ state: { selectedService: "Motion Control & Servo Eğitimi" } })} className="text-center" style={{ cursor: 'pointer' }}>
                <div style={{ width: '100%', height: '80px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                    <img src="/uploads/servo.jpg" alt="Motion Control" style={{ maxHeight: '75px', maxWidth: '100%', objectFit: 'contain' }} onError={(e) => { e.target.src="/images/servo.jpg" }} />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#444' }}>Motion Control</span>
            </div>
        </div>
    )}
</div>



                    </div>
                </Container>
            </div>

        
        </header>
    );
};

export default Header;
